import { render } from "./UploadFileComponent.vue?vue&type=template&id=08676282"
import script from "./UploadFileComponent.vue?vue&type=script&lang=js"
export * from "./UploadFileComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/import/UploadFileComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08676282"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08676282', __exports__)) {
    api.reload('08676282', __exports__)
  }
  
  module.hot.accept("./UploadFileComponent.vue?vue&type=template&id=08676282", () => {
    api.rerender('08676282', render)
  })

}


export default __exports__